<template>
  <div class="row">
    <div class="col s12 l6">
      <div class="card card-subnav card-subnav-bg">
        <div class="card-content">
          <span
            :class="[
              { 'card-title-toggle': content.toggle !== undefined },
              'card-title',
              'col-header'
            ]"
            @click="() => content.toggle && toggleCardList()"
          >
            <i
              :class="`small material-icons section-icon  ${content.icon.css}`"
            >
              {{ content.icon.name }}
            </i>
            <span class="card-title-text">{{ title }}</span>
            <span v-if="content.toggle" class="badge cardsubnav-toggle-menu">
              <i class="material-icons">more_vert</i>
            </span>
          </span>
          <ul
            v-if="
              (content.scrollnav && content.scrollnav.length > 0) ||
                route.children.length > 1
            "
            :class="{
              'card-list': true,
              toggle: content.toggle
            }"
            ref="cardList"
          >
            <template v-if="content.scrollnav">
              <li
                v-for="item in content.scrollnav"
                :key="`subcard-nav-${item.scroll}`"
              >
                <i class="material-icons">chevron_right</i>
                <a href v-scroll-into-view="`#${item.scroll}`">
                  {{ item.text }}
                </a>
              </li>
            </template>
            <template v-else-if="route.children.length > 1">
              <router-link
                v-for="item in route.children"
                tag="li"
                :key="`subcard-nav-${item.name}`"
                :to="{ name: item.name }"
              >
                <i class="material-icons">chevron_right</i>
                <a href @click="navigate($event, item)">{{ item.text }}</a>
              </router-link>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ScrollIntoView } from "../directives/ScrollIntoView.directive";

export default {
  name: "navigation-card",

  directives: {
    ScrollIntoView
  },

  props: {
    alias: {
      type: String,
      default: "home"
    },
    content: {
      type: Object
    }
  },

  data() {
    return {
      route: this.getRouteByName(),
      title: this.content.title
    };
  },

  methods: {
    getRouteByName: function() {
      const alias = this.alias;
      const routes = this.$router.options.routes.filter(
        route => route.routeAlias === alias
      );

      // return first found route object, first route in router otherwise
      return routes.length ? routes[0] : this.$router.options.routes[0];
    },
    getSubrouteByName: function(name) {
      return this.route.children.filter(route => route.name === name)[0];
    },
    navigate: function(evt, item) {
      this.title = this.getSubrouteByName(item.name).title;
    },

    toggleCardList() {
      this.$refs.cardList.classList.toggle("open");
    }
  }
};
</script>

<style lang="less" scoped></style>
